/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect, useContext } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import "src/styling/reset.css"
import "src/styling/fonts.css"
import "src/styling/base.css"
import { container } from "./layout.module.css"

import Modal from "src/components/core/templates/modal"
import Header from "src/components/core/organisms/header"
import Footer from "src/components/core/organisms/footer"
import CartSidebar from "src/components/core/organisms/cart-sidebar"
import MenuSidebar from "src/components/core/organisms/menu-sidebar"

import { CartContext } from "src/context/CartContext"
import { ModalContext } from "src/context/ModalContext"


const Layout = ( { children } ) => {
  const data = useStaticQuery( graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const { sidebarIsOpen } = useContext( CartContext )
  const { modalIsOpen } = useContext( ModalContext )

  useEffect( () => {
    window.document.querySelector( "body" ).style.overflow =
      sidebarIsOpen.sidebar || modalIsOpen ? "hidden" : "auto"
    // window.document.querySelector( "body" ).style.overflow = "override"
  }, [ sidebarIsOpen, modalIsOpen ] )

  useEffect( () => {
    if ( modalIsOpen ) {
      //console.log("modal will open here")
    }
  }, [ modalIsOpen ] )

  return (
    <>
      <Header siteTitle={ data.site.siteMetadata?.title || `Title` } />
      <MenuSidebar />
      <CartSidebar />
      <Modal />
      <div className={ container }>
        <main>{ children }</main>
        <footer>
          <Footer />
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
